import React from 'react';
import { useDispatch } from 'react-redux';
import Header from '../../../../../../components/Stake/header';
import ZenWbtcUniIcon from '../../../../../../assets/images/ZEN_WBTC.svg';
import * as zenWbtcUniStakeActions from '../../../../../../actions/zen-wbtc-uni-stake-actions';
import ErrorComponent from '../../../../../../components/Stake/frame/error';

const Error = () => {
  const dispatch = useDispatch();

  return (
    <>
      <Header icon={ZenWbtcUniIcon} title='zenWBTC Error' />
      <ErrorComponent submitClick={() => dispatch(zenWbtcUniStakeActions.stakeReset())} />
    </>
  );
};

export default Error;
